import { FC, useCallback, useState } from "react";
import { Input } from "@src/lib/ui/Input";
import { Label } from "@src/lib/ui/Label";
import { Button } from "@src/lib/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@src/lib/ui/Dialog";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  text?: string;
  initialLink?: string;
  hideTextField?: boolean;
  onComplete: (text: string, link: string) => void;
};

const EditLinkDialog: FC<Props> = ({
  open,
  onOpenChange,
  text: initialText = "",
  initialLink = "",
  hideTextField = false,
  onComplete,
}) => {
  const [text, setText] = useState(initialText);
  const [link, setLink] = useState(initialLink);

  const handleSave = useCallback(() => {
    const normalizedLink = link.startsWith("http") ? link : `https://${link}`;
    onComplete(text, normalizedLink);
    onOpenChange(false);
  }, [text, link, onComplete, onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Edit Link</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3 px-1">
          {!hideTextField && (
            <div className="flex flex-col gap-1.5">
              <Label>Text</Label>
              <Input value={text} onChange={(e) => setText(e.target.value)} />
            </div>
          )}
          <div className="flex flex-col gap-1.5">
            <Label>Link</Label>
            <Input value={link} onChange={(e) => setLink(e.target.value)} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button disabled={!link} onClick={handleSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditLinkDialog;
